export default __webpack_public_path__ + "static/media/hero_shot_tiny.5f2cc8df.webp";